import { cnpjUtils } from "@/utils/cnpjUtils";
import { z } from "zod";

const onlyDigits = (value: string) => value.replace(/\D/g, "");

const whatsapp = (message: string) =>
  z.string().refine(value => {
    const digits = onlyDigits(value);
    return digits.length === 10 || digits.length === 11;
  }, message);

/**
 * Campos do formulário de indicação da parceria Alpha7, na ordem do Google
 * Forms original: os obrigatórios são os que o especialista precisa para
 * chamar o responsável e dar retorno ao vendedor.
 */
export const partnerFormSchema = z.object({
  clientTradeName: z.string().trim().min(2, "Informe o nome fantasia da farmácia."),
  clientContactName: z.string().trim().min(2, "Informe o nome do responsável."),
  clientWhatsapp: whatsapp("WhatsApp inválido. Confira o DDD e o número."),
  clientCnpj: z
    .string()
    .refine(
      value => cnpjUtils.normalizeCNPJ(value).length > 0,
      "Informe o CNPJ da farmácia."
    )
    .refine(
      value => cnpjUtils.isValidCNPJ(value),
      "CNPJ inválido. Confira os 14 caracteres."
    ),
  storesCount: z.number().int().positive().optional(),
  sellerName: z.string().trim().min(2, "Informe o seu nome."),
  sellerWhatsapp: whatsapp("WhatsApp inválido. Confira o DDD e o número."),
  sellerEmail: z.string().trim().email("E-mail inválido. Confira o endereço."),
  notes: z.string().trim().max(1000, "Resuma em até 1000 caracteres.").optional(),
  honeypot: z.string().optional(),
});

export type PartnerFormValues = z.infer<typeof partnerFormSchema>;

export const partnerFormDefaults: PartnerFormValues = {
  clientTradeName: "",
  clientContactName: "",
  clientWhatsapp: "",
  clientCnpj: "",
  storesCount: undefined,
  sellerName: "",
  sellerWhatsapp: "",
  sellerEmail: "",
  notes: "",
  honeypot: "",
};
